const validaCns = (vlrCNS) => {
    if (!vlrCNS) {
        return false;
    }

    vlrCNS = vlrCNS.replace(/\s/g, '')

    var soma = new Number;
    var resto = new Number;
    var dv = new Number;
    var pis = new String;
    var resultado = new String;
    var tamCNS = vlrCNS.length;
    if ((tamCNS) != 15) {
        return false;
    }
    pis = vlrCNS.substring(0,11);
    soma = (((Number(pis.substring(0,1))) * 15) +
        ((Number(pis.substring(1,2))) * 14) +
        ((Number(pis.substring(2,3))) * 13) +
        ((Number(pis.substring(3,4))) * 12) +
        ((Number(pis.substring(4,5))) * 11) +
        ((Number(pis.substring(5,6))) * 10) +
        ((Number(pis.substring(6,7))) * 9) +
        ((Number(pis.substring(7,8))) * 8) +
        ((Number(pis.substring(8,9))) * 7) +
        ((Number(pis.substring(9,10))) * 6) +
        ((Number(pis.substring(10,11))) * 5));
    resto = soma % 11;
    dv = 11 - resto;
    if (dv == 11) {
        dv = 0;
    }
    if (dv == 10) {
        soma = (((Number(pis.substring(0,1))) * 15) +
            ((Number(pis.substring(1,2))) * 14) +
            ((Number(pis.substring(2,3))) * 13) +
            ((Number(pis.substring(3,4))) * 12) +
            ((Number(pis.substring(4,5))) * 11) +
            ((Number(pis.substring(5,6))) * 10) +
            ((Number(pis.substring(6,7))) * 9) +
            ((Number(pis.substring(7,8))) * 8) +
            ((Number(pis.substring(8,9))) * 7) +
            ((Number(pis.substring(9,10))) * 6) +
            ((Number(pis.substring(10,11))) * 5) + 2);
        resto = soma % 11;
        dv = 11 - resto;
        resultado = pis + "001" + String(dv);
    } else {
        resultado = pis + "000" + String(dv);
    }
    if (vlrCNS != resultado) {
        return false;
    } else {
        return true;
    }
}

const validaCnsProvisorio = (vlrCNS) => {
    if (!vlrCNS) {
        return false;
    }

    let resto, soma

    vlrCNS = vlrCNS.replace(/\s/g, '')

    var tamCNS = vlrCNS.length;
    if ((tamCNS) != 15) {
        return false;
    }

    soma =
        ((Number(vlrCNS.substring(0,1))) * 15) +
        ((Number(vlrCNS.substring(1,2))) * 14) +
        ((Number(vlrCNS.substring(2,3))) * 13) +
        ((Number(vlrCNS.substring(3,4))) * 12) +
        ((Number(vlrCNS.substring(4,5))) * 11) +
        ((Number(vlrCNS.substring(5,6))) * 10) +
        ((Number(vlrCNS.substring(6,7))) * 9) +
        ((Number(vlrCNS.substring(7,8))) * 8) +
        ((Number(vlrCNS.substring(8,9))) * 7) +
        ((Number(vlrCNS.substring(9,10))) * 6) +
        ((Number(vlrCNS.substring(10,11))) * 5) +
        ((Number(vlrCNS.substring(11,12))) * 4) +
        ((Number(vlrCNS.substring(12,13))) * 3) +
        ((Number(vlrCNS.substring(13,14))) * 2) +
        ((Number(vlrCNS.substring(14,15))) * 1)

    resto = soma % 11

    if (resto != 0) {
        return false
    } else {
        return true
    }
}

export default vlrCNS => {
    return validaCns(vlrCNS) || validaCnsProvisorio(vlrCNS)
}